import { InputType } from 'config'

export const BrokerInvitationPlaceholders: string[] = [
  'address',
  'title',
  'userCompanyName',
  'userCompanyType',
  'accountType',
  'name',
  'email',
  'phone',
  'phoneExt',
  'brokerSSN',
  'brokerNmls',
  'todayDate',
  'companyAddress',
  'companyTitle',
  'aeName',
  'aePhone',
  'aeEmail',
  'aeEmail',
]

export const defaultInputs = (): Record<string, InputType> => {
  return {
    subject: {
      inputType: 'text',
      title: 'Subject',
      required: true,
    },
    content: {
      inputType: 'textarea',
      title: 'Content',
      required: true,
      rows: 15,
    },
    button: {
      inputType: 'text',
      title: 'Button',
      required: true,
    },
  }
}
